import React, { useState, useEffect } from 'react';
import { Checkbox } from '@mui/material';

export const HeaderMenu = ({ id, selectionModel, setSelectionModel, courses }) => {
  const [isChecked, setIsChecked] = useState(false);

  // Sync checkbox state with selection model
  useEffect(() => {
    const selectedItemsLength = Object.keys(selectionModel)?.length;
    setIsChecked(selectedItemsLength > 0 && selectedItemsLength === courses.length);
  }, [selectionModel, courses]);

  const selectedItemsLength = Object.keys(selectionModel)?.length;

  const handleSelectAll = () => {
    setSelectionModel(
      courses?.reduce((selectedItems, course) => {
        selectedItems[course.CRN] = course;
        return selectedItems;
      }, {}),
    ); // Select all rows
    setIsChecked(true);
  };

  const handleClearSelection = () => {
    setSelectionModel({}); // Clear all selection
    setIsChecked(false);
  };

  return (
    <Checkbox
      id={`${id}__checkbox`}
      size="small"
      checked={isChecked}
      indeterminate={selectedItemsLength > 0 && selectedItemsLength < courses.length}
      onChange={(e) => {
        if (e.target.checked) {
          handleSelectAll();
        } else {
          handleClearSelection();
        }
      }}
    />
  );
};
